module.exports = __webpack_public_path__ + "img/model.65be8715.gif";